import Vue from 'vue';
import VueRouter from 'vue-router';
import TheMenu from '../views/pages/TheMenu';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'the-menu',
    component: TheMenu,
    meta: {
      layout: 'DefaultLayout',
    },
  },
  {
    path: '/select-item',
    name: 'select-item',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: TheMenu,

    meta: {
      layout: 'DefaultLayout',
      showItemDialog: true,
    },
  },
  {
    path: '/basket',
    name: 'basket',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: TheMenu,

    meta: {
      layout: 'DefaultLayout',
      basketVisible: true,
    },
  },
  {
    path: '/basket/select-item',
    name: 'basket-select-item',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: TheMenu,

    meta: {
      layout: 'DefaultLayout',
      basketVisible: true,
      showItemDialog: true,
    },
  },
  {
    path: '/checkout',
    name: 'checkout',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: TheMenu,

    meta: {
      layout: 'DefaultLayout',
      basketVisible: true,
      showCheckoutDialog: true,
    },
  },
  {
    path: '/success',
    name: 'success',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: TheMenu,

    meta: {
      layout: 'DefaultLayout',
      showDialogSuccess: true,
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

// always navigate to home on page load
router.replace('/');

export default router;
